import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h9v-1a1 1 0 0 1-1-1V3a1 1 0 0 0-1-1H2Zm1 2h2v2H3V4Zm3 3h2v2H6V7Z"
    />
  </svg>
);
export default IconLentaFilledSizeXs;
